import { Box, BoxProps, Icon, Tooltip } from "@chakra-ui/react";
import { MdVerified } from "react-icons/md";

export default function AttributeIsCertificationIcon(props: BoxProps) {
  return (
    <Tooltip
      label="This attribute indicates receipt of a specific certification."
      hasArrow
      openDelay={500}
      textAlign="center"
      maxW="15em"
      lineHeight="normal"
    >
      <Box
        as="span"
        position="relative"
        top=".15em"
        left=".1em"
        ml=".15em"
        {...props}
      >
        <Icon as={MdVerified} />
      </Box>
    </Tooltip>
  );
}
